import type {
  CreateParagraphArgs,
  HeaderElement,
  HeadersElement,
  HeadersElementProps,
} from '../internal';
import { createDefaultParagraph, HeaderType } from '../internal';

export function createDefaultHeaderByType(
  type: HeaderType,
  options: CreateParagraphArgs = {}
): HeaderElement {
  return {
    children: [createDefaultParagraph(options)],
    suggestedEdits: [],
    type,
  };
}

interface CreateHeadersArgs extends CreateParagraphArgs {
  headersProps?: Partial<HeadersElementProps>;
}

export function createDefaultHeaders(args: CreateHeadersArgs = {}): HeadersElement {
  const { headersProps, ...createParagraphArgs } = args;

  return {
    children: [
      createDefaultHeaderByType(HeaderType.Default, createParagraphArgs),
      createDefaultHeaderByType(HeaderType.FirstPage, createParagraphArgs),
      createDefaultHeaderByType(HeaderType.Even, createParagraphArgs),
    ],
    headerMargin: 0.5,
    suggestedEdits: [],
    type: 'headers',
    ...headersProps,
  };
}
